/**
 * Created by fuwanting on 26/06/2018
 **/

export const amapKey = "8fb6f44a970ee48b2b54249229b912a2";

export const locationBaiduKey = "KT9ZW9XBBLbtBH0wqkwbF4k6dO45cmTb";

export const appId = "wx880e2280f284dabe";
// export const appId = "wxb5ba71fe419d0e61";//测试公众号wxb5ba71fe419d0e61,wxefa829114077740b(qyq)
// export const retUrl = 'http://47.108.138.198:6815/wx/author';//开发
// export const retUrl = 'https://api.ynsjj88.com/wx/author';//生产
export const retUrl = 'http://api.dev.ynsjj88.com/wx/author';//测试
export const returnUrl = encodeURIComponent(retUrl);
export const WeChat = `https://open.weixin.qq.com/connect/oauth2/authorize?redirect_uri=${returnUrl}&appid=${appId}&response_type=code&scope=snsapi_base&state=aa`;

export function oldWeiChatAuthor(state) {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?redirect_uri=${returnUrl}&appid=${appId}&response_type=code&scope=snsapi_base&state=${state}`;
}
export function weiChatAuthor(state) {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${retUrl}&response_type=code&scope=snsapi_userinfo&state=${state}`;
}

export const lxddtappId = "wx519cc8bcf1e5633c";
export const lxddtusername = "gh_48c1d61d33d0";
export const wss = "wss://wss.dev.ynsjj88.com";
// export const wss = "wss://wss.ynsjj88.com";
// export const wss = "ws://192.168.1.22:8091";




// WEBPACK FOOTER //
// ./src/config/config.js